/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Switch } from "react-router-dom";
import { useLocation } from "react-router";

import Home from "../../Home";
import User from "../../Users";
import NewUser from "../../Users/NewUser";
import Company from "../../Company";
import NewCompany from "../../NewCompany";
import EditCompany from "../../EditCompany";
import Chat from "../../Chat";
import Reports from "../../Reports";
import Profile from "../../Profile";
import Customers from "../../Customers";
import SkuteFeed from "../../SkuteFeed";
import SkuteConfig from "../../SkuteConfig";
import SkuteScheduling from "../../SkuteScheduling";
import SkuteSatisfactionSurvey from "../../SkuteSatisfactionSurvey";
import NewCustomer from "../../Customers/NewCustomer";
import ChangePassword from "../../ChangePassword";
import CompanyCategories from "../../CompanyCategories";
import UserCompany from "../../Users/UserCompany";

import "../style.css";
import { useNotification } from "hooks/notification";
import PrivateRoute from "./privateRoute";
import { toast } from "react-toastify";
import { i18n } from "translate/i18n";
import SubscriptionsReport from "pages/SubscriptionsReport";

export default function SubRoutes() {
  const [company, setCompany] = useState();
  const { selectedCompany, isNetworkOnline } = useNotification();
  const location = useLocation();
  const reconnected = useRef(false);

  useEffect(() => {
    if (!isNetworkOnline) {
      toast.warning(i18n.t("offline"));
      reconnected.current = true;
    } else if (reconnected.current) {
      toast.success(i18n.t("reconnected"));
      reconnected.current = false;
    }
  }, [isNetworkOnline, location]);

  useEffect(() => {
    setCompany(selectedCompany.id);
  }, [selectedCompany]);

  return (
    <>
      <div
        key={company}
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
        }}
      >
        <Switch>
          <PrivateRoute
            path="/dashboard/changepassword"
            component={ChangePassword}
          />
          <PrivateRoute
            path="/dashboard/newuser/:id"
            component={NewUser}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/usercompany/:id"
            component={UserCompany}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/subscriptionsreport"
            component={SubscriptionsReport}
            isPrivate
          />
          <PrivateRoute path="/dashboard/user" component={User} isPrivate />
          <PrivateRoute
            path="/dashboard/newuser"
            component={NewUser}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/company"
            component={Company}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/newcompany"
            component={NewCompany}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/editcompany/:id"
            component={EditCompany}
            isPrivate
          />
          <PrivateRoute path="/dashboard/chat" component={Chat} isPrivate />
          <PrivateRoute
            path="/dashboard/categories"
            component={CompanyCategories}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/customer"
            component={Customers}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/newcustomer/:id"
            component={NewCustomer}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/newcustomer"
            component={NewCustomer}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/reports/:id"
            component={Reports}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/profile"
            component={Profile}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/skute/feed"
            component={SkuteFeed}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/skute/config"
            component={SkuteConfig}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/skute/rating"
            component={SkuteSatisfactionSurvey}
            isPrivate
          />
          <PrivateRoute
            path="/dashboard/skute/scheduling"
            component={SkuteScheduling}
            isPrivate
          />
          <PrivateRoute path="/" component={Home} />
        </Switch>
      </div>
    </>
  );
}
